import {NgModule} from "@angular/core";
import {RouterModule, ROUTES, Routes} from "@angular/router";
import {MsalBroadcastService, MsalGuard, MsalService} from "@azure/msal-angular";
import {AuthService} from "./services/auth.service";
import {NotFoundComponent} from "./components/pages/not-found/not-found.component";
import {HomeComponent} from "./components/pages/home/home.component";
import {BlankComponent} from "./components/shared/blank/blank.component";
import {GeneralComponent} from "./components/shared/template/general/general.component";
import {DocumentsComponent} from "./components/pages/documents/documents.component";
import {LanguageComponent} from "./components/shared/template/language/language.component";
import {BadRequestComponent} from "./components/pages/bad-request/bad-request.component";
import {FunctionsComponent} from "./components/pages/functions/functions.component";

const routes: Routes = [
  {
    path: "",
    component: HomeComponent,
    pathMatch: "full",
    canActivate: [MsalGuard],
  },
  {
    path: "utils",
    component: FunctionsComponent,
    pathMatch: "full",
    canActivate: [MsalGuard],
  },
  {
    path: "page",
    children: [
      {
        path: "primary",
        children: [
          {
            path: "**",
            component: GeneralComponent,
            canActivate: [MsalGuard],
          },
        ],
        canActivate: [MsalGuard],
      },
      {
        path: "secondary",
        children: [
          {
            path: "**",
            component: GeneralComponent,
            canActivate: [MsalGuard],
          },
        ],
        canActivate: [MsalGuard],
      },
      {
        path: "rework",
        children: [
          {
            path: "**",
            component: GeneralComponent,
            canActivate: [MsalGuard],
          },
        ],
        canActivate: [MsalGuard],
      },
      {
        path: "declaration",
        children: [
          {
            path: "**",
            component: GeneralComponent,
            canActivate: [MsalGuard],
          },
        ],
        canActivate: [MsalGuard],
      },
      {
        path: "eur",
        children: [
          {
            path: "**",
            component: GeneralComponent,
            canActivate: [MsalGuard],
          },
        ],
        canActivate: [MsalGuard],
      },
      {
        path: "balance",
        children: [
          {
            path: "**",
            component: GeneralComponent,
            canActivate: [MsalGuard],
          },
        ],
        canActivate: [MsalGuard],
      },
		{
			path: "receipt",
			children: [
				{
					path: "**",
					component: GeneralComponent,
					canActivate: [MsalGuard],
				},
			],
			canActivate: [MsalGuard],
		},
      {
        path: "warehousing",
        children: [
          {
            path: "**",
            component: GeneralComponent,
            canActivate: [MsalGuard],
          },
        ],
        canActivate: [MsalGuard],
      },
      {
        path: "masterdata",
        children: [/**
          {
            path: "translation",
            component: LanguageComponent,
            canActivate: [MsalGuard],
          },
			  */
          {
            path: "**",
            component: GeneralComponent,
            canActivate: [MsalGuard],
          },

        ],
        canActivate: [MsalGuard],
      },
      {
        path: "documents",
        children: [
          {
            path: "other",
            component: DocumentsComponent,
            canActivate: [MsalGuard],
          },
          {
            path: "**",
            component: GeneralComponent,
            canActivate: [MsalGuard],
          },
        ],
        canActivate: [MsalGuard],
      },
      {
        path: "management",
        children: [/**
          {
            path: "languages",
            component: LanguageComponent,
            canActivate: [MsalGuard],
          },
          {
            path: "translation",
            component: LanguageComponent,
            canActivate: [MsalGuard],
          },
			  */
          {
            path: "**",
            component: GeneralComponent,
            canActivate: [MsalGuard],
          },
        ],
        canActivate: [MsalGuard],
      },
    ],
    canActivate: [MsalGuard],
  },
  {
    path: "blank",
    component: BlankComponent,
  },
  {
    path: "404",
    component: NotFoundComponent,
  },
  {
    path: "400",
    component: BadRequestComponent,
  },
  {
    path: "**",
    redirectTo: "/404",
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [
    AuthService,
    MsalService,
    MsalBroadcastService,
    {
      provide: ROUTES,
      useFactory: () => {
        return [...routes];
      },
      multi: true,
      deps: [AuthService, MsalService, MsalBroadcastService],
    },
  ],
})
export class AppRoutingModule {
}
